module.exports = __webpack_public_path__ + "img/banner .d7d4cc61.png";